export class Room {
    /**
     * @var number
     */
    _length: number;

    /**
     * @var number
     */
    _width: number;

    /**
     * @var
     */
    _height: number;

    get length(): number {
        return this._length;
    }

    set length(value: number) {
        this._length = value;
    }

    get width(): number {
        return this._width;
    }

    set width(value: number) {
        this._width = value;
    }

    get height(): number {
        return this._height;
    }

    set height(value: number) {
        this._height = value;
    }

}



// WEBPACK FOOTER //
// ./src/app/room.ts